
class NavbarController {
    constructor($state, $rootScope) {
        this.$state = $state;
        this.$rootScope = $rootScope;
    }

}

NavbarController.$inject= ['$state', '$rootScope'];

export {NavbarController};



// WEBPACK FOOTER //
// ./app/components/common/navbar/navbar.controller.js